<template>
  <div class="tab-pane-inner tab-pane-role">
    <Card class="config-card" :bordered="false" :dis-hover="true">
      <div class="card-body-inner">
        <!-- 1 身份设定 -->
        <div class="rp-block">
          <div class="rp-block__title">身份设定</div>
          <div class="rp-block__content">
            <div class="tag-group tag-group--rp-options">
              <span
                v-for="(item, index) in form.identities"
                :key="'id-' + index"
                :title="tagFullLabel(item)"
                class="rp-opt-tag-tooltip-wrap"
              >
                <Tag
                  closable
                  :color="item.active ? 'primary' : 'default'"
                  class="identity-tag rp-opt-tag"
                  @click.native="selectIdentity($event, index)"
                  @on-close="removeIdentity(index)"
                >
                  {{ item.text }}
                </Tag>
              </span>
              <Input
                v-if="identityCustomEditing"
                ref="identityCustomInput"
                v-model="identityCustomDraft"
                size="small"
                placeholder="输入身份名称"
                class="rp-inline-custom-input"
                @on-enter="submitIdentityCustom"
                @on-blur="submitIdentityCustom"
              />
              <Button
                v-else
                type="dashed"
                size="small"
                class="tag-add-btn"
                @click="startIdentityCustom"
              >+ 自定义</Button>
            </div>
          </div>
        </div>

        <!-- 2 沟通风格 -->
        <div class="rp-block">
          <div class="rp-block__title">沟通风格</div>
          <div class="rp-block__content">
            <div class="tag-group tag-group--rp-options">
              <span
                v-for="(item, index) in form.communicationStyles"
                :key="'st-' + index"
                :title="tagFullLabel(item)"
                class="rp-opt-tag-tooltip-wrap"
              >
                <Tag
                  closable
                  :color="item.active ? 'primary' : 'default'"
                  class="style-tag rp-opt-tag"
                  @click.native="toggleStyle($event, index)"
                  @on-close="removeCommunicationStyle(index)"
                >
                  {{ item.text }}
                </Tag>
              </span>
              <Input
                v-if="styleCustomEditing"
                ref="styleCustomInput"
                v-model="styleCustomDraft"
                size="small"
                placeholder="输入风格名称"
                class="rp-inline-custom-input"
                @on-enter="submitStyleCustom"
                @on-blur="submitStyleCustom"
              />
              <Button
                v-else
                type="dashed"
                size="small"
                class="tag-add-btn"
                @click="startStyleCustom"
              >+ 自定义</Button>
            </div>
            <!-- 临时隐藏「已选」汇总行；恢复展示请将 showCommunicationSelectedSummary 设为 true -->
            <div
              v-if="showCommunicationSelectedSummary && activeStyleLabels.length"
              class="rp-selected-line"
            >
              <span class="rp-selected-prefix">已选：</span>
              <span
                v-for="row in activeStyleLabels"
                :key="'sel-st-' + row.index"
                :title="row.text"
                class="rp-selected-tag-tooltip-wrap"
              >
                <Tag
                  closable
                  color="primary"
                  class="rp-selected-pill"
                  @on-close="deactivateStyle(row.index)"
                >{{ row.text }}</Tag>
              </span>
            </div>
          </div>
        </div>

        <!-- 3 姓名昵称 -->
        <div class="rp-block">
          <div class="rp-block__title">姓名昵称</div>
          <div class="rp-block__content">
            <Input
              v-model="form.roleName"
              placeholder="请输入昵称"
              :maxlength="10"
              show-word-limit
            />
          </div>
        </div>
        <!-- 性别：UI 与表单/保存逻辑均已下线，勿启用 form.gender -->
        <!--
        <div class="form-row">
          <span class="label">性别</span>
          <RadioGroup v-model="form.gender">
            <Radio label="男">男</Radio>
            <Radio label="女">女</Radio>
          </RadioGroup>
        </div>
        -->

        <!-- 4 角色描述 -->
        <div class="rp-block rp-block--role-desc">
          <div class="rp-role-desc-head">
            <div class="rp-role-desc-head__title">
              <span class="rp-required">*</span>角色描述
            </div>
          </div>
          <div class="rp-block__content">
            <!-- <div class="role-desc-guide">
              <div
                class="role-desc-guide__bar"
                role="button"
                tabindex="0"
                @click="roleDescGuideExpanded = !roleDescGuideExpanded"
                @keyup.enter="roleDescGuideExpanded = !roleDescGuideExpanded"
              >
                <span class="role-desc-guide__bar-title">配置指引</span>
                <a
                  href="javascript:void(0)"
                  class="role-desc-guide__toggle"
                  @click.stop="roleDescGuideExpanded = !roleDescGuideExpanded"
                >{{ roleDescGuideExpanded ? '收起示例' : '查看示例' }}</a>
              </div>
              <div v-show="roleDescGuideExpanded" class="role-desc-guide__panel">
                <p class="role-desc-guide__p">
                  <span class="role-desc-guide__label">建议：</span>
                  明确大模型的身份、职责，以及向客户开口时的自我介绍。设定得越具体，AI的代入感越强，开口越自然。
                </p>
                <p class="role-desc-guide__p">
                  <span class="role-desc-guide__label">例如：</span>
                  你是XX教育机构的课程顾问小张。你的职责是回访意向客户并解答课程疑问。通话开始时，请自称“小张”，不要说“我是AI”或“我是机器人”。
                </p>
              </div>
            </div> -->
            <LlmTextareaWithInsertParam
              ref="roleDescInput"
              v-model="form.roleDesc"
              :rows="22"
              placeholder="请描述 AI 助手的角色与输出要求..."
              :maxlength="1000"
              :customer-info-params="form.customerInfoParams"
              :memory-enabled="memoryEnabled"
            />
          </div>
        </div>
      </div>
    </Card>
  </div>
</template>

<script>
import TextareaWithInsertParam from '../shared/TextareaWithInsertParam.vue'

export default {
  name: 'LlmRolePersonaTab',
  components: { LlmTextareaWithInsertParam: TextareaWithInsertParam },
  props: {
    form: {
      type: Object,
      required: true,
    },
    memoryEnabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      identityCustomEditing: false,
      identityCustomDraft: '',
      styleCustomEditing: false,
      styleCustomDraft: '',
      roleDescGuideExpanded: false,
      /** 沟通风格「已选：」标签行；临时关闭，需要时再改为 true */
      showCommunicationSelectedSummary: false,
    };
  },
  computed: {
    activeStyleLabels() {
      const list = this.form.communicationStyles || [];
      return list
        .map((item, index) => ({ item, index }))
        .filter(({ item }) => item && typeof item === 'object' && item.active)
        .map(({ item, index }) => ({
          text: String((item.text ?? item.label ?? '') || '').trim(),
          index,
        }))
        .filter((row) => row.text);
    },
  },
  methods: {
    tagFullLabel(item) {
      if (!item || item.text == null) return '';
      return String(item.text);
    },
    selectIdentity(e, index) {
      this.form.identities.forEach((item, i) => {
        this.$set(item, 'active', i === index);
      });
    },
    toggleStyle(e, index) {
      const item = this.form.communicationStyles[index];
      this.$set(item, 'active', !item.active);
    },
    deactivateStyle(index) {
      const item = this.form.communicationStyles[index];
      if (item && typeof item === 'object') this.$set(item, 'active', false);
    },
    removeIdentity(index) {
      const list = this.form.identities;
      if (!Array.isArray(list) || index < 0 || index >= list.length) return;
      list.splice(index, 1);
      if (!list.length) return;
      const hasActive = list.some((x) => x && x.active);
      if (!hasActive) {
        list.forEach((item, i) => this.$set(item, 'active', i === 0));
      }
    },
    removeCommunicationStyle(index) {
      const list = this.form.communicationStyles;
      if (!Array.isArray(list) || index < 0 || index >= list.length) return;
      list.splice(index, 1);
    },
    startIdentityCustom() {
      this.identityCustomEditing = true;
      this.identityCustomDraft = '';
      this.$nextTick(() => {
        const el = this.$refs.identityCustomInput;
        if (el && typeof el.focus === 'function') el.focus();
      });
    },
    cancelIdentityCustom() {
      this.identityCustomDraft = '';
      this.identityCustomEditing = false;
    },
    submitIdentityCustom() {
      if (!this.identityCustomEditing) return;
      const t = (this.identityCustomDraft || '').trim();
      if (!t) {
        this.cancelIdentityCustom();
        return;
      }
      this.form.identities.push({ text: t, active: false });
      this.identityCustomDraft = '';
      this.identityCustomEditing = false;
    },
    startStyleCustom() {
      this.styleCustomEditing = true;
      this.styleCustomDraft = '';
      this.$nextTick(() => {
        const el = this.$refs.styleCustomInput;
        if (el && typeof el.focus === 'function') el.focus();
      });
    },
    cancelStyleCustom() {
      this.styleCustomDraft = '';
      this.styleCustomEditing = false;
    },
    submitStyleCustom() {
      if (!this.styleCustomEditing) return;
      const t = (this.styleCustomDraft || '').trim();
      if (!t) {
        this.cancelStyleCustom();
        return;
      }
      this.form.communicationStyles.push({ text: t, active: false });
      this.styleCustomDraft = '';
      this.styleCustomEditing = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.tab-pane-role {
  width: 100%;
  max-width: 100%;

  ::v-deep .config-card.ivu-card .ivu-card-body {
    padding: 16px 0;
  }
}

/* 角色与人设：标题与内容分行、已选区、配置指引 */
.rp-block {
  margin-bottom: 20px;
  text-align: left;
  &--role-desc {
    margin-bottom: 0;
  }
  &__title {
    font-size: 14px;
    font-weight: 600;
    color: #262626;
    margin-bottom: 10px;
    text-align: left;
  }
  &__content {
    width: 100%;
  }
}
.rp-required {
  color: #ed4014;
  margin-right: 4px;
}
.rp-selected-prefix {
  font-size: 13px;
  color: #8c8c8c;
}
::v-deep .rp-inline-custom-input.ivu-input-wrapper {
  width: 160px;
  vertical-align: middle;
  line-height: normal;
}
::v-deep .rp-inline-custom-input .ivu-input.ivu-input-small {
  height: 28px !important;
  min-height: 28px !important;
  line-height: 26px !important;
  padding: 0 11px !important;
  font-size: 14px !important;
  border-radius: 4px !important;
  box-sizing: border-box !important;
}
::v-deep .rp-inline-custom-input .ivu-input.ivu-input-small::placeholder {
  font-size: 14px !important;
  color: #bfbfbf !important;
}

.rp-opt-tag-tooltip-wrap {
  display: inline-flex;
  vertical-align: middle;
  max-width: min(320px, 100%);
  min-width: 0;
}
.rp-selected-tag-tooltip-wrap {
  display: inline-flex;
  vertical-align: middle;
  max-width: min(320px, 100%);
  min-width: 0;
}

.tag-group {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  flex: 1;
  ::v-deep .ivu-tag {
    margin-right: 0;
  }
  .identity-tag,
  .style-tag {
    cursor: pointer;
  }
}

.tag-group--rp-options {
  gap: 10px;
  min-width: 0;
  ::v-deep .rp-opt-tag-tooltip-wrap .rp-opt-tag.ivu-tag {
    max-width: 100%;
  }
  ::v-deep .rp-opt-tag.ivu-tag {
    display: inline-flex !important;
    align-items: center;
    vertical-align: middle;
    max-width: 100%;
    min-width: 0;
    height: 28px;
    line-height: 26px;
    padding: 0 14px !important;
    margin: 0 !important;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 400;
    border: 1px solid #d9d9d9 !important;
    background: #fff !important;
    color: #262626 !important;
    box-sizing: border-box;
  }
  ::v-deep .rp-opt-tag.ivu-tag .ivu-tag-text {
    flex: 1 1 auto;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 14px !important;
    font-weight: 400 !important;
    line-height: 26px !important;
  }
  ::v-deep .rp-opt-tag.ivu-tag .ivu-icon-ios-close {
    flex-shrink: 0;
    margin-left: 4px;
  }
  ::v-deep .rp-opt-tag.ivu-tag.ivu-tag-default .ivu-tag-text {
    color: #262626 !important;
  }
  ::v-deep .rp-opt-tag.ivu-tag.ivu-tag-primary .ivu-tag-text,
  ::v-deep .rp-opt-tag.ivu-tag.ivu-tag-primary .ivu-tag-text.ivu-tag-color-white {
    color: #0050b3 !important;
  }
  ::v-deep .rp-opt-tag.ivu-tag.ivu-tag-primary {
    border-color: #1890ff !important;
    background: #e6f7ff !important;
    color: #1890ff !important;
  }
  /* 选中态浅蓝底上，关闭按钮默认偏浅不易辨认 */
  ::v-deep .rp-opt-tag.ivu-tag.ivu-tag-primary .ivu-icon-ios-close {
    color: #8cbfff !important;
    opacity: 1 !important;
    font-size: 16px !important;
    font-weight: 600;
    top: 0 !important;
  }
  ::v-deep .rp-opt-tag.ivu-tag.ivu-tag-primary .ivu-icon-ios-close:hover {
    color: #002766 !important;
  }
  ::v-deep .tag-add-btn.ivu-btn {
    height: 28px !important;
    padding: 0 14px !important;
    margin: 0 !important;
    border-radius: 4px !important;
    font-size: 14px !important;
    line-height: 26px !important;
    border: 1px dashed #91d5ff !important;
    background: #fff !important;
    color: #1890ff !important;
    &:hover {
      border-color: #1890ff !important;
      color: #1890ff !important;
      background: #fafafa !important;
    }
  }
}

.rp-selected-line {
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  ::v-deep .rp-selected-tag-tooltip-wrap .rp-selected-pill.ivu-tag {
    max-width: 100%;
    display: inline-flex !important;
    align-items: center;
    min-width: 0;
  }
  ::v-deep .rp-selected-tag-tooltip-wrap .rp-selected-pill.ivu-tag .ivu-tag-text {
    flex: 1 1 auto;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  ::v-deep .rp-selected-tag-tooltip-wrap .rp-selected-pill.ivu-tag .ivu-icon-ios-close {
    flex-shrink: 0;
  }
  ::v-deep .rp-selected-pill.ivu-tag {
    height: 22px;
    line-height: 21px;
    padding: 0 12px !important;
    border-radius: 4px;
    font-size: 12px;
    border: 1px solid #bae7ff !important;
    background: #f0f9ff !important;
    color: #0050b3 !important;
  }
  ::v-deep .rp-selected-pill.ivu-tag .ivu-tag-text,
  ::v-deep .rp-selected-pill.ivu-tag .ivu-tag-text.ivu-tag-color-white {
    font-size: 12px !important;
    color: #0050b3 !important;
  }
  ::v-deep .rp-selected-pill.ivu-tag .ivu-icon-ios-close {
    top: 0;
    font-size: 12px !important;
    color: #1890ff !important;
  }
}

.rp-role-desc-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 10px;
  width: 100%;
  &__title {
    font-size: 14px;
    font-weight: 600;
    color: #262626;
    text-align: left;
    flex: 1;
    min-width: 0;
  }
}

.rp-insert-param-dropdown {
  flex-shrink: 0;
}
.rp-insert-param-btn {
  height: 28px !important;
  padding: 0 12px !important;
  border: 1px solid #91d5ff !important;
  border-radius: 4px !important;
  background: #e6f7ff !important;
  color: #1890ff !important;
  font-size: 14px !important;
  line-height: 26px !important;
  &:hover {
    border-color: #1890ff !important;
    color: #0050b3 !important;
    background: #bae7ff !important;
  }
}

.role-desc-guide {
  margin-bottom: 10px;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;

  &__bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 16px;
    cursor: pointer;
    user-select: none;
    background: #f4f7fa;
  }
  &__bar-title {
    font-size: 14px;
    font-weight: 600;
    color: #262626;
  }
  &__toggle {
    font-size: 12px;
    color: #909399;
  }
  &__panel {
    padding: 16px;
    border-top: 1px solid #e4e7ed;
    background: #fafafa;
  }
  &__p {
    margin: 0 0 12px;
    font-size: 13px;
    color: #595959;
    line-height: 1.6;
    text-align: left;
    &:last-child {
      margin-bottom: 0;
    }
  }
  &__label {
    display: inline;
    font-weight: 600;
    color: #262626;
  }
}
</style>
